import { FilterFieldDef } from './../covance-filter/covance-filter.models';
import { FilterFieldType } from '../covance-filter';
import { MandatoryFilter } from './mandatory-filter';

export const projectFilter: FilterFieldDef = {
    title: 'Project',
    queryParam: 'project',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect,
    leaveOnlySelectedItems: true,
};

export const protocolFilter: FilterFieldDef = {
    title: 'Protocol',
    queryParam: 'protocol',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect,
    leaveOnlySelectedItems: true,
};

export const protocolMasterFilter: FilterFieldDef = {
    title: 'Protocol',
    queryParam: MandatoryFilter.Protocol,
    isServerSideFilter: true,
    leaveOnlySelectedItems: true,
    type: FilterFieldType.External,
};

export const siteFilter: FilterFieldDef = {
    title: 'Site',
    queryParam: 'site',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect
};

export const ageFilter: FilterFieldDef = {
    title: 'eQuery Age',
    queryParam: 'age',
    isServerSideFilter: true,
    type: FilterFieldType.Age
};

export const statusFilter: FilterFieldDef = {
    title: 'Status',
    queryParam: 'status',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect
};

export const unreadOnlyFilter: FilterFieldDef = {
    title: 'Unread Only?',
    queryParam: 'unreadOnly',
    isServerSideFilter: true,
    type: FilterFieldType.Checkbox
};

export const unrespondedOnlyFilter: FilterFieldDef = {
    title: 'Unresponded Only?',
    queryParam: 'unrespondedOnly',
    isServerSideFilter: true,
    type: FilterFieldType.Checkbox
};

export const dateFilter: FilterFieldDef = {
    title: 'Posted',
    queryParam: 'date',
    isServerSideFilter: true,
    type: FilterFieldType.DateRange
};

export const labReportTypeFilter: FilterFieldDef = {
    title: 'Type',
    queryParam: 'type',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect
};

export const sponsorFilter: FilterFieldDef = {
    title: 'Sponsor',
    queryParam: MandatoryFilter.Sponsor,
    isServerSideFilter: true,
    leaveOnlySelectedItems: true,
    type: FilterFieldType.MultiSelect,
};

export const sponsorMasterFilter: FilterFieldDef = {
    title: 'Sponsor',
    queryParam: MandatoryFilter.Sponsor,
    isServerSideFilter: true,
    leaveOnlySelectedItems: true,
    type: FilterFieldType.External,
};

export const externalProtocolFilter: FilterFieldDef = {
    title: 'Protocol',
    queryParam: 'protocol',
    isServerSideFilter: true,
    type: FilterFieldType.External,
    leaveOnlySelectedItems: true,
};

export const subCategoryFilter: FilterFieldDef = {
    title: 'Subcategory',
    queryParam: 'subcategory',
    isServerSideFilter: true,
    type: FilterFieldType.Select
};

export const expirationDateFilter: FilterFieldDef = {
    title: 'Expiration Date Range',
    queryParam: 'expirationDate',
    isServerSideFilter: true,
    type: FilterFieldType.DateRange,
};

export const shippedDateFilter: FilterFieldDef = {
    title: 'Shipped Date Range',
    queryParam: 'date',
    isServerSideFilter: true,
    type: FilterFieldType.DateRange,
};

export const kitTypeFilter: FilterFieldDef = {
    title: 'Kit Type',
    queryParam: 'kitType',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect,
};

export const documentTypeFilter: FilterFieldDef = {
    title: 'Document Type',
    queryParam: 'documentType',
    isServerSideFilter: true,
    type: FilterFieldType.MultiSelect
};

export const sentDateFilter: FilterFieldDef = {
    title: 'Sent Time',
    queryParam: 'sentDate',
    isServerSideFilter: true,
    type: FilterFieldType.DateRange
};
